import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {DIAGNOSTIC_REPORTS} from '@/patient/routing/paths';

import DiagnosticReports from '@/patient/views/DiagnosticReports';

function DiagnosticReportLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === DIAGNOSTIC_REPORTS;
  return isRoot ? <DiagnosticReports /> : <Outlet />;
}

export const Route = createFileRoute('/(patient)/diagnostic-reports')({
  component: DiagnosticReportLayout
});
